import useSWR from "swr";
import { chatRepository, type ChatsQuery } from "../data/chat-repository";
import type { PaginatedResponse } from "../../pagination/data/types/pagination";
import type { Chat } from "../data/types/chat";

export function useChatsPaginated(query: ChatsQuery) {
  const cacheKey = `chats-paginated-${JSON.stringify(query)}`;

  const result = useSWR<PaginatedResponse<Chat>>(
    cacheKey,
    () => chatRepository.getChatsPaginated(query),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  return {
    ...result,
    isLoading: result.isLoading ?? (!result.data && result.isValidating),
  };
}
